import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import weui from "weui.js";
import defaultHead from "../../assets/image/default-head.png";
import {
  Cell,
  CellBody,
  CellButton,
  CellHeader,
  Cells,
  CellsTips,
  Input,
  Label,
  MediaBoxAppMsg,
  Panel,
  PanelBody
} from "../../components/weui";
import { userService } from "../../services";
import { selectUser } from "../../stores";
import { urls } from "../../urls";
import { getAxiosError } from "../../utils";


export const BindingPush = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const [username, setUsername] = useState("");
  const [pass, setPass] = useState("");
  const canBinding = useMemo(() => username !== "" && pass !== "", [username, pass]);

  useEffect(() => {
    weui.alert("您已进入推送绑定配置界面", { title: "!!! 注意 !!!" });
  }, []);

  const handleBinding = useCallback(async e => {
    const loading = weui.loading("正在绑定...");
    try {
      await userService.bindingEBMS(username, pass);
      setUsername("");
      setPass("");
      weui.toast("绑定成功", {
        duration: 3000,
        callback: () => navigate(urls.home())
      });
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      loading.hide();
    }
  }, [username, pass, setUsername, setPass, navigate]);

  return (
    <>
      <Panel>
        <PanelBody>
          <MediaBoxAppMsg icon={ user?.pic || defaultHead } title={ user?.name } desc="" />
        </PanelBody>
      </Panel>
      <Cells>
        <Cell>
          <CellHeader>
            <Label htmlFor="elUser">登陆用户</Label>
          </CellHeader>
          <CellBody>
            <Input id="elUser"
              placeholder="请输入您的登陆用户名称"
              value={ username }
              onChange={ e => setUsername(e.target.value) } />
          </CellBody>
        </Cell>
        <Cell>
          <CellHeader>
            <Label htmlFor="elPwd">登陆密码</Label>
          </CellHeader>
          <CellBody>
            <Input id="elPwd"
              placeholder="请输入您的登陆密码"
              type="password"
              value={ pass }
              onChange={ e => setPass(e.target.value) } />
          </CellBody>
        </Cell>
      </Cells>

      <CellsTips>在此输入您的管理登陆信息, 验证通过后, 会将当前微信账号与您的管理账号关联, 后续系统运维推送信息会推送至此微信账号.</CellsTips>

      <Cells>
        <CellButton type="primary" onClick={ handleBinding }
          disabled={ !canBinding }>绑定</CellButton>
      </Cells>
    </>
  );
};
